module.exports = __webpack_public_path__ + "static/1-98bd4be2ac0e4948ab4dc1e04d60c987.png";